import React, { useState, useEffect } from 'react';
import TextEditor from '@components/form-elements/TextEditor';
import { fetchJson } from '@utils/fetchJson';
import { formatTimeAgo } from '@utils/timeUtils';
import CommentItem from './CommentItem';
import NoDataVector from './NoDataVector'; // optional
import { API_BASE_URL } from '../../config';
const CommentsList = ({ record_id, record_type = 'task' }) => {
  const [comments, setComments] = useState([]);
  const [sortOrder, setSortOrder] = useState('DESC');
  const [editorContent, setEditorContent] = useState('');
  const [loadstate, setloadstate] = useState(false);
  
  const [pagingInfo, setPagingInfo] = useState({
  curPage: 0,
  prevPage: 0,
  pageLimit: 0,
  nextpage: 0,
  totalRecords: 0,
  loadstate:false,
  start: 0,
  end: 0,
});
  const [loading, setLoading] = useState(false);
  const [showEditor, setShowEditor] = useState(false);
  const fetchComments = async (page = 0, order = sortOrder) => {
    setLoading(true);
    const params = {
      status: 'active',
      orderBy: 'created_date',
      order,
      record_id:record_id,
      type:record_type,
      curpage: page,
    };
    const res = await fetchJson(`${API_BASE_URL}/comments`, {
      method: 'POST',
      body: JSON.stringify(params),
    });

    if (res?.flag === 'S') {
      setComments((prev) => (page === 0 ? res.data : [...prev, ...res.data]));
      setloadstate(res.loadstate);
      if (res.paginginfo) setPagingInfo(res.paginginfo);
    }
    setLoading(false);
  };

  const addComment = async () => {
    if (!editorContent) return;
    const body = {
      body: editorContent,
      created_date: null,
      status: 'active',
      mentions: [],
      record_id:record_id,
      type:record_type,
    };
    const res = await fetchJson(`${API_BASE_URL}/comment/`, {
      method: 'PUT',
      body: JSON.stringify(body),
    });
    if (res?.flag === 'S') {
      setEditorContent('');
      setShowEditor(false);
      fetchComments(0);
    }
  };

  const toggleSort = () => {
    const newOrder = sortOrder === 'ASC' ? 'DESC' : 'ASC';
    setSortOrder(newOrder);
    fetchComments(0, newOrder);
  };

  useEffect(() => {
    //if(record_id)
    fetchComments(0);

  }, [record_id]);

  return (
    <div className="p-0">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-semibold">
          All Comments ({pagingInfo?.totalRecords || 0})
        </h2>
        <button onClick={toggleSort} className="text-sm text-blue-500">
          {sortOrder === 'ASC' ? 'Oldest First' : 'Newest First'}
        </button>
      </div>

      {!showEditor ? (
        <button onClick={() => setShowEditor(true)} className="text-sm w-full justify-left flex rounded p-3 border text-blue-500 mb-2"> Add a comment...</button>
      ) : (
      <>
      <TextEditor value={editorContent} showEditorInitially={true} onChange={setEditorContent} />
      <div className="mt-2 flex gap-2">
      <button
        onClick={addComment}
        disabled={!editorContent.trim()}
        className="bg-blue-600 text-white px-4 py-1 rounded text-sm"
      >
        Post Comment
      </button>
      <button
        onClick={() => {
          setEditorContent('');
          setShowEditor(false);
        }}
        className="text-sm text-gray-500 hover:underline"
      >
        Cancel
      </button>
    </div>
  </>
)}
      {/* <button
        onClick={addComment}
        className="mt-2 bg-blue-600 text-white px-4 py-1 rounded"
      >
        Post Comment
      </button> */}

      <div className="mt-6 space-y-4">
        {comments.length === 0 && !loading ? (
          <></>
          // <NoDataVector message="No comments yet!" />
        ) : (
          comments.map((item) => (
            <CommentItem
              key={item.comment_id}
              item={item}
              record_type={record_type}
              onUpdated={() => fetchComments(0)}
            />
          ))
        )}
        {pagingInfo && loadstate === true && (
          <button
            onClick={() => fetchComments(pagingInfo.nextpage)}
            className="text-sm text-blue-500 mt-4"
          >
            Load More
          </button>
        )}
       
      </div>
    </div>
  );
};
export default CommentsList;
